<div *ngIf="fetchData" id="popup1">
    <div class="divider-bottom" fxLayout="row wrap" fxLayoutAlign="center center">
        <h1 mat-dialog-title>
            <b>MyCarePlan<sup>®</sup> is now retrieving your data</b>
            <!-- <button style="margin-left: 60px;background-color: #00cccc; color: #fff;" [mat-dialog-close]="data" cdkFocusInitial>x</button> -->
        </h1>
    </div>
    <div mat-dialog-content fxLayout="row wrap" fxLayoutAlign="center center" style="margin-top: 50px; margin-bottom: 50px;">
        <img src="{{imgUrl}}loading.gif" width="90">
        <h5>{{messages[index]}}</h5>
    </div>
    <div mat-dialog-actions fxLayout="row wrap" fxLayoutAlign="center center">
        <div fxFlex.gt-sm="15" fxFlex.gt-xs="100" fxFlex="100">
            <img src="{{imgUrl}}blue-btn-logo.png" width="90">
        </div>
        <div fxFlex.gt-sm="85" fxFlex.gt-xs="100" fxFlex="100">
            <p class="footer">MyCarePlan<sup>®</sup> has been approved to access your information. We do not share your data with anyone and you will have full control over who receives this data.</p>
        </div>
    </div>
</div>

<div *ngIf="success" id="popup2">
    <div class="divider-bottom" fxLayout="row wrap" fxLayoutAlign="center center">
        <h1 mat-dialog-title>
            <b>MyCarePlan<sup>®</sup> is now retrieving your data</b>
            <!-- <button style="margin-left: 60px;background-color: #00cccc; color: #fff;" [mat-dialog-close]="data" cdkFocusInitial>x</button> -->
        </h1>
    </div>
    <div mat-dialog-content fxLayout="row wrap" fxLayoutAlign="center center">
        <div fxFlex.gt-sm="30" fxFlex.gt-xs="100" fxFlex="100" fxLayoutAlign="center center">
            <img src="{{imgUrl}}blue-btn-tick-logo.png" width="90">
        </div>
        <div fxFlex.gt-sm="70" fxFlex.gt-xs="100" fxFlex="100">
            <h5><b>Congratulations! Your care plan is now ready.</b></h5>
            <P>Please review the following:</P>
            <ul>
                <li>Where you stand on your preventive screens</li>
                <li>Your medications list, your chronic conditions</li>
                <li>The list of Physicians that you have visited in the last 4 years</li>
                <li>A summary of your co-pays in the last 4 years</li>
            </ul>
            <button mat-raised-button class="btn" data-dismiss="modal" (click)="getStartedBtnClick()" [mat-dialog-close]="data">Get Started!</button>
        </div>
    </div>
    <div mat-dialog-actions fxLayout="row wrap" fxLayoutAlign="center center">
        <div fxFlex.gt-sm="15" fxFlex.gt-xs="100" fxFlex="100">
            <img src="{{imgUrl}}blue-btn-logo.png" width="90">
        </div>
        <div fxFlex.gt-sm="85" fxFlex.gt-xs="100" fxFlex="100">
            <p class="footer">MyCarePlan<sup>®</sup> has been approved to access your information. We do not share your data with anyone and you will have full control over who receives this data.</p>
        </div>
    </div>
</div>